import { render, staticRenderFns } from "./housekeepingServFeeConfigManageRel.vue?vue&type=template&id=3d4bff10&scoped=true"
import script from "./housekeepingServFeeConfigManageRel.vue?vue&type=script&lang=js"
export * from "./housekeepingServFeeConfigManageRel.vue?vue&type=script&lang=js"
import style0 from "./housekeepingServFeeConfigManageRel.vue?vue&type=style&index=0&id=3d4bff10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4bff10",
  null
  
)

export default component.exports